import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
// import { $ } from 'protractor';
import * as $ from 'jquery';
declare var $: any;

@Component({ 
  selector: 'app-submission',
  templateUrl: './submission.component.html',
  styleUrls: ['./submission.component.css'],
  // providers: [UploadFileService]
})
export class SubmissionComponent implements OnInit {
  selectedFiles: FileList;
  currentFileUpload: File;

  moreHospitalData = false;
  cliamData: Array<any> = [];
  claimInfo: [];
  loading: boolean;
  noDataFound: boolean;
  mobileNumber: string;
  error: string;
  selectedFile: File; 
  selectedFileName: string;
  fileArray = [];
  fileNameArray = [];
  uploader: any;
  uploading: boolean;
  insurerId: string;
  tpaId: string;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private router: Router, private serviceURLService: serviceURLService) { }

  ngOnInit() {
    this.getClaimDetails();
  }

  // To get saved claim data by mobile number
  getClaimDetails() {
    this.loading = true;
    this.mobileNumber = localStorage.getItem("mobileNumber");
    console.log(this.mobileNumber);
    this.serviceURLService.getClaimDataByMobile(this.mobileNumber).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
      this.loading = false;
      $("#submitOpenModal").modal("show");
      this.cliamData = successData.response.pamResponse.data;
      this.insurerId = this.cliamData[0].insurerId;
      this.tpaId = this.cliamData[0].tpaId;

    }, errorData => {   
      $("#submitOpenModal").modal("hide");
      this.loading = false;   
      
      $("#noRegisterClaimsModal").modal("show");
      if (errorData.error.status === 403) {
        this.error = errorData.error.message;
        
      }
    });
  }
  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}

